import './index.css'
import './i18n'

import App from './App'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { initSentry } from './lib/sentry'
import { getTokenWhenAppStart } from './infrastructure/apis'

initSentry()
getTokenWhenAppStart()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)

reportWebVitals()
